
import { Component, Mixins, Prop } from 'vue-property-decorator';
import ListFilters from 'ah-common-lib/src/common/components/listing/ListFilters.vue';
import SizeSelector from 'ah-common-lib/src/common/components/SizeSelector.vue';
import { FeeStatus } from 'ah-api-gateways/models/feesAndCharges/fees';

// TODO composition API
@Component({ components: { SizeSelector } })
export default class OutstandingFeesFilters extends Mixins(ListFilters) {
  @Prop({ default: false }) hideSearch!: string | boolean;

  @Prop({ default: false }) hideOwnerType!: string | boolean;

  private search = '';

  private pageSize = 10;

  private userType: 'CLIENTS' | 'PARTNERS' = 'CLIENTS';

  private feeStatuses = [];

  get feeStatusOptions() {
    return [
      {
        label: 'Ok',
        value: FeeStatus.OK,
      },
      {
        label: 'Overdue',
        value: FeeStatus.OVERDUE,
      },
      {
        label: 'Due',
        value: FeeStatus.DUE,
      },
    ];
  }

  get displayOwnerType() {
    return this.hideOwnerType === false;
  }

  get displaySearch() {
    return this.hideSearch === false;
  }

  get knownFilters() {
    return [
      {
        key: 'query',
        getter: () => (this.displaySearch && this.search) || undefined,
        setter: (value: any) => (this.search = value),
      },
      {
        key: 'type',
        getter: () => (this.displayOwnerType && this.userType) || undefined,
        setter: (value: any) => (this.userType = value),
      },
      {
        key: 'feeStatus',
        getter: () => this.feeStatuses || undefined,
        setter: (value: any) => (this.feeStatuses = value),
      },
    ];
  }

  get knownSortAndPageParams() {
    return [
      {
        key: 'pageSize',
        getter: () => this.pageSize || undefined,
        setter: (value: any) => (this.pageSize = value),
      },
    ];
  }
}
